import roles from '../AdminRoles/roles.enum';

const hasAcccess = (permissionKey: any, accessType: string) => {
  const permissions: any = localStorage.getItem('permissions');
  if (localStorage.getItem('adminType') === roles.superadmin
  || localStorage.getItem('adminType') === null
  || localStorage.getItem('adminType') === undefined) {
    return true;
  }

  const list = JSON.parse(permissions);
  // a role saved before a module existed has no entry for it (ENTER VICE, Special Posts): no access, no crash
  const permission = Array.isArray(list) ? list.find((ele: any) => ele.key === permissionKey) : undefined;
  return permission ? Boolean(permission[accessType]) : false;
};

export default hasAcccess;
